import { Injectable } from "@angular/core";
import { Response } from "@angular/http";
import { Observable } from "rxjs/Observable";

import { CrudService } from "@atenea-cms";
import { Country } from "./country.model";

@Injectable()
export class CountryService extends CrudService {
  getRootUrl(): string {
    return "countries";
  }

  save(country: Country) {
    return super.save(country);
  }

  saveMultiple(countries: Array<Country>) {
    return super.saveMultiple(countries);
  }
}



// WEBPACK FOOTER //
// ./libs/atenea-cms-brand/src/countries/shared/country.service.ts